function App() {
  return (
    <div
      className="min-h-screen bg-white dark:bg-[#0a0a0a] text-neutral-900 dark:text-white flex flex-col items-center justify-center px-6 transition-colors duration-300"
      style={{ fontFamily: "'Satoshi', sans-serif" }}
    >
      <main className="max-w-2xl w-full flex flex-col items-start gap-16">
        <header className="flex items-center gap-3">
          <img
            src={`${process.env.PUBLIC_URL}/monogram.png`}
            alt=""
            className="h-7 dark:invert"
          />
          <span className="text-[15px] font-medium tracking-[0.2em] uppercase text-neutral-500 dark:text-neutral-400">
            Nytro Labs
          </span>
        </header>

        <div className="flex flex-col gap-8">
          <p className="text-[32px] sm:text-[40px] leading-[1.2] font-medium tracking-tight text-neutral-900 dark:text-white">
            An applied AI lab.
          </p>
          <p className="text-[18px] sm:text-[20px] leading-[1.6] text-neutral-600 dark:text-neutral-400 max-w-xl">
            We are a group of engineers helping businesses automate workflows
            with AI.
          </p>
          <p className="text-[18px] sm:text-[20px] leading-[1.6] text-neutral-400 dark:text-neutral-500">
            We have much to learn, try, and build.
          </p>
        </div>

        <footer>
          <a
            href="mailto:careers@nytrolabs.com"
            className="text-[15px] text-neutral-400 dark:text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors duration-300"
          >
            Join our team &rarr;
          </a>
        </footer>
      </main>
    </div>
  );
}

export default App;
